import { MODAL_STATE } from '../actions/modal';

const initialState = {
  modalState: 'not_open',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case MODAL_STATE:
      return {
        ...state,
        modalState: action.status,
      };
    default:
      return state;
  }
};

export default reducer;
